import React from 'react';

const InfoSvg = (): JSX.Element => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.2" clipPath="url(#clip0_1031_13258)">
      <path
        d="M7.01607 1.83113e-05C10.878 0.00876797 14.0158 3.16739 13.9999 7.02982C13.9841 10.8808 10.8353 14.0088 6.98381 14C3.12192 13.9913 -0.015921 10.8326 -6.2221e-05 6.97021C0.0157965 3.11927 3.16458 -0.00873135 7.01607 1.83113e-05ZM7.00131 1.26981C3.8651 1.26872 1.27575 3.8537 1.26973 6.99209C1.26372 10.1267 3.84541 12.7187 6.9849 12.7302C10.1282 12.7417 12.7345 10.1398 12.7301 6.99428C12.7258 3.85643 10.1381 1.27091 7.00131 1.26981Z"
        fill="black"
      />
      <path
        d="M6.35868 8.47567C6.35868 7.86483 6.35157 7.25454 6.36087 6.64371C6.36797 6.17943 6.66546 5.90546 7.08436 5.95249C7.42778 5.99077 7.63777 6.25544 7.63996 6.67707C7.64434 7.71609 7.6416 8.75511 7.6416 9.79413C7.6416 9.98553 7.64871 10.1775 7.63832 10.3683C7.61699 10.7582 7.36052 11.024 7.01108 11.0311C6.65398 11.0388 6.3718 10.7637 6.3636 10.3623C6.35102 9.73398 6.36032 9.10455 6.36032 8.47567C6.35922 8.47567 6.35923 8.47567 6.35868 8.47567Z"
        fill="black"
      />
      <path
        d="M6.99086 4.65855C6.51838 4.65472 6.14761 4.27411 6.15691 3.80217C6.16566 3.34555 6.54135 2.9726 6.99578 2.96877C7.45952 2.96549 7.8445 3.35211 7.84286 3.82022C7.84122 4.29434 7.46663 4.66292 6.99086 4.65855Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1031_13258">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoSvg;
